import React, { useState } from "react";
import { IMAGES, FAQS } from "../mock";
import { ButtonLink, Kicker } from "../components/UI";
import { PageHero } from "./FindRenovate";
import { Plus, Minus } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

export default function FAQ() {
  const ref = useReveal();
  const [open, setOpen] = useState(0);
  return (
    <div ref={ref}>
      <PageHero
        kicker="FAQs"
        title={<>Questions, <span className="text-gold-soft italic">Answered.</span></>}
        sub="Everything you're wondering about finding, designing, and renovating your home."
        image={IMAGES.materials2}
        imageKey="hero_faq"
      />

      <section className="py-24 md:py-32 bg-cream">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="divide-y divide-cream-dark border-t border-b border-cream-dark">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="reveal">
                  <button onClick={() => setOpen(isOpen ? -1 : i)} className="w-full flex items-start justify-between gap-6 py-7 text-left group">
                    <span className={`font-serif text-xl md:text-2xl transition-colors duration-300 ${isOpen ? "text-gold" : "text-navy group-hover:text-gold"}`}>{f.q}</span>
                    <span className="shrink-0 mt-1 text-navy">{isOpen ? <Minus size={22} strokeWidth={1.5} /> : <Plus size={22} strokeWidth={1.5} />}</span>
                  </button>
                  <div className={`overflow-hidden transition-all duration-500 ${isOpen ? "max-h-60 opacity-100 pb-7" : "max-h-0 opacity-0"}`}>
                    <p className="font-sans text-charcoal/70 leading-relaxed max-w-3xl font-light">{f.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-cream-dark text-center">
        <div className="max-w-2xl mx-auto px-6">
          <Kicker>Still Wondering?</Kicker>
          <h2 className="reveal font-serif font-medium text-navy text-3xl md:text-4xl mt-4">Let's Have a Conversation.</h2>
          <div className="reveal flex justify-center mt-8"><ButtonLink to="/contact" variant="navy">Start Your Project</ButtonLink></div>
        </div>
      </section>
    </div>
  );
}
